import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormTemplate } from './formtemplate';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
@Injectable({
  providedIn: 'root'
})
export class FormtemplateService {

    baseUrl: string = environment.serviceUrl;
  constructor(private httpClient: HttpClient) { }


  getFormTemplates(): Observable<FormTemplate[]> {
    return this.httpClient.get<FormTemplate[]>(this.baseUrl + 'api/FormTemplateApi');
  }

  Post(frmTemplate: FormTemplate): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormTemplateApi/add', frmTemplate, { headers: header, observe: 'response' })
  }

  Put(frmTemplate: FormTemplate): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/FormTemplateApi/Update', frmTemplate, { headers: header, observe: 'response' })
  }
  Delete(frmTemplate: FormTemplate) {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormTemplateApi/activeordeactive', frmTemplate, { headers: header, observe: 'response' })
  }

  getFieldAlias(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormTemplateApi/GetActiveFieldAlias');
  }
  getMasterTable(): Observable<any>{
  return this.httpClient.get<any>(this.baseUrl + 'api/FormTemplateApi/GetActiveMasterTables');     
  }
}
